import { useEffect, useState } from 'react';

/**
 * Returns `false` during SSR and the first client render, `true` after mount.
 *
 * Gate client-only markup (portals, `window`-derived or persisted-store state)
 * behind it so the first client render stays identical to the server HTML —
 * otherwise React detects a hydration mismatch and discards the entire server
 * tree (#418/#423).
 */
export const useMounted = (): boolean => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
};
